
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input('header-text') text: string;
  @Output() openMenu: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onOpenMenu(event){
    event.cancelBubble = true;
    this.openMenu.emit(event);
  }

}


// WEBPACK FOOTER //
// ./src/app/header/header.component.ts